module.exports = __webpack_public_path__ + "images/533e102445b86c1ee724df6dd163ad0a.svg";